/* Courted · Plan it (a sheet): with your partner or just you, one of the times you're both free this week
   (from Home's week; any of the next seven days when Home hasn't worked it out yet), when, for how long, and the
   booking note. It goes on the week as a plan (source 'courted', the place as its id), so Home counts it as time
   together on purpose and your partner is asked (0045). */
import React from 'react';
import * as H from './helpers.js';
import { Ico, Sheet } from './ui.jsx';

const { useState, useMemo } = React;
const TIMES = []; for (let m = 7 * 60; m <= 23 * 60; m += 15) TIMES.push(m);
const DOW = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export function PlanSheet({ name, kind, cat, partner, me, slots, today, sunsetFor, words, wxFor, initialDate, initialStart, instead, onPlan, onClose }) {
  // the days to offer: your free times together, or (none known yet) the next seven days — with the day you came
  // for in them either way (H.withDays), never swapped for the first
  const days = useMemo(() => {
    if (slots && slots.length) return H.withDays(slots, [initialDate], today);
    const out = [];
    for (let i = 0; i < 7; i++) {
      const date = H.addDays(today, i), d = new Date(date + 'T12:00:00');
      out.push({ date, dow: DOW[d.getDay()], label: DOW[d.getDay()] + ' ' + d.getDate(), all: false, from: i === 0 ? 18 * 60 : 18 * 60, to: 23 * 60, unknown: true,
        short: { wd: DOW[d.getDay()].slice(0, 3), n: String(d.getDate()), hrs: i === 0 ? 'Today' : '' } });
    }
    return H.withDays(out, [initialDate], today);
  }, [slots, today, initialDate]);
  const first = initialDate ? days.findIndex((d) => d.date === initialDate) : -1;
  // a time without a sitter first, when there is one that fits (withCare)
  const fitsFree = days.findIndex((d) => !d.unknown && H.fits(d, kind, sunsetFor(d.date)) && !d.sitter);
  const fitsFirst = fitsFree >= 0 ? fitsFree : days.findIndex((d) => H.fits(d, kind, sunsetFor(d.date)));
  const [i, setI] = useState(first >= 0 ? first : Math.max(0, fitsFirst));
  const slot = days[i];
  const dflt = H.planDefaults(kind, slot.unknown ? null : slot, cat);
  const [start, setStart] = useState(initialStart != null && initialDate && slot.date === initialDate ? initialStart : dflt.start);
  const [mins, setMins] = useState(dflt.minutes);
  const [who, setWho] = useState('both');
  const [busy, setBusy] = useState(false);
  const pick = (k) => { setI(k); const d = H.planDefaults(kind, days[k].unknown ? null : days[k], cat); setStart(d.start); };
  const go = async () => { setBusy(true); try { await onPlan({ date: slot.date, start, minutes: mins, who: partner ? who : 'me' }); } finally { setBusy(false); } };
  const note = slot.unknown ? slot.dow + '.' : H.dayNote(slot, kind, sunsetFor(slot.date), words, wxFor ? wxFor(slot.date) : null);
  return (
    <Sheet title={'Plan ' + name} onClose={onClose}
      foot={<>
        <p className="co-whonote">{partner ? (who === 'both' ? 'We’ll ask ' + partner.name + '.' : 'Just for you. It shows on ' + partner.name + '’s week as “just ' + me.name + '”.') : 'It goes on your week.'}</p>
        <button type="button" className="dv-btn dv-btn-pop" disabled={busy} onClick={go}>{busy ? 'Planning…' : 'Plan it'}</button>
      </>}>
      {partner ? (
        <div className="dv-seg co-who" role="radiogroup" aria-label="Who">
          <button type="button" role="radio" aria-checked={who === 'both' ? 'true' : 'false'} onClick={() => setWho('both')}>With {partner.name}</button>
          <button type="button" role="radio" aria-checked={who === 'me' ? 'true' : 'false'} onClick={() => setWho('me')}>Just me</button>
        </div>
      ) : null}
      <span className="co-ey">{slots && slots.length ? (partner ? 'When you’re both free' : 'When you’re free') : 'Which day'}</span>
      <div className="co-days" role="radiogroup" aria-label="Day">
        {days.map((d, k) => (
          <button key={d.date} type="button" role="radio" aria-checked={k === i ? 'true' : 'false'} className={'co-day' + (k === i ? ' on' : '')} onClick={() => pick(k)}
            aria-label={d.label + (d.short.hrs ? ', ' + d.short.hrs : '')}>
            <small>{d.short.wd}</small><b className="co-display">{d.short.n}</b>{d.short.hrs ? <span className="hrs">{d.short.hrs}</span> : null}
          </button>
        ))}
      </div>
      <p className="co-daynote">{note}{instead ? ' Instead of ' + instead + '.' : ''}</p>
      <div className="dv-list dv-list-inset co-when">
        <label className="dv-row"><span className="dv-row-text"><span>At</span></span>
          <select className="co-select" value={start} onChange={(e) => setStart(Number(e.target.value))}>{TIMES.map((m) => <option key={m} value={m}>{H.ampm(m, true)}</option>)}</select></label>
        <label className="dv-row"><span className="dv-row-text"><span>For about</span></span>
          <select className="co-select" value={mins} onChange={(e) => setMins(Number(e.target.value))}>{(H.DURATIONS.includes(mins) ? H.DURATIONS : [...H.DURATIONS, mins].sort((a, b) => a - b)).map((m) => <option key={m} value={m}>{H.hoursWords(m)}</option>)}</select></label>
      </div>
      {H.bookingLive(cat, today) ? (
        cat.booking_url ? <a className="co-booking" href={cat.booking_url} target="_blank" rel="noopener noreferrer"><Ico n="i-info" s /><span>{cat.booking_note}{cat.booking_until ? '. It’s needed until ' + H.shortDate(cat.booking_until, words && words.country) + '.' : '.'}</span><Ico n="i-external" s /></a>
          : <p className="co-booking"><Ico n="i-info" s /><span>{cat.booking_note}</span></p>
      ) : null}
    </Sheet>
  );
}

